import { GetterTree } from "vuex";
import { CategoryState } from "@/store/category/type";
import { RootState } from "@/store/type";
import { Category } from "@/models/category";
import { filterData } from "@/utils/categoryFilter";

export const getters: GetterTree<CategoryState, RootState> = {
  activeCategory: (state) => (categorySlug: string): Category | undefined => {
    // TODO : improve this with a recursive call to all sub children and so on

    if (state.categoryTree) {
      const categoryTree = state.categoryTree;
      if (categoryTree.slug === categorySlug) {
        return categoryTree;
      }

      if (categoryTree.children && categoryTree.children.length > 0) {
        const activeCategory = filterData(categoryTree.children, function (item) {
          return item.slug === categorySlug;
        });
        if (activeCategory.length !== 0) {
          return activeCategory[0];
        } else {
          return undefined;
        }
      }
    }
  },
  getCategoryTree: (state) => {
    return state.categoryTree;
  },
};